<template>
  <o-modal :active="isActive" :canCancel="false" class="modal-sm">
    <div class="modal-card">
      <header class="modal-card-head has-background-white">
        <div class="modal-card has-text-dark has-text-weight-bold">{{ modalHeader }}</div>
      </header>
      <section class="modal-card-body is-visible  has-background-white has-text-black-bis">
        <div class="is-italic has-text-weight-semibold line-height">
          {{ orderTitle }}
        </div>
        <div class="has-text-weight-normal is-regular line-height py-1">
          {{ rowData.name }}
        </div>
        <div class="is-divider my-0"></div>
        <div class="bim-doc-modal">
          <field-file-list
            :order="rowData"
            prop="files"
            isIconField
            :isShipping="true"
            :isBIMPLUS="isBIMPLUS"
            :cardDetails="orderDetails"
            @saveFiles="saveFiles()"
            />
        </div>
      </section>
      <footer
        class="modal-card-foot is-justify-content-flex-end is-align-items-center has-background-white"
      >
        <div class="buttons">
          <button
            class="button has-text-weight-bold has-background-black-bis has-text-white"
            @click="closeModal"
          >
            Done
          </button>
        </div>
      </footer>
    </div>
    <o-loading
      :full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></o-loading>
  </o-modal>
</template>

<script>
import { reactive, toRefs } from 'vue';
export default {
  name: 'TableDocuments',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => {},
    },
    modalHeader: {
      type: String,
      default: 'Edit Delivery Documents'
    },
    orderTitle: {
      type: String,
      default: 'Delivery'
    },
    isBIMPLUS: {
      type: Boolean,
      default: false,
    },
    orderDetails: {
      type: Object,
      default: () => {},
    }
  },
  setup(props, { emit }) {

    const data = reactive({
      isLoading: false,
    });

    const saveFiles = () => {
      emit('saveDocs')
    }

    const closeModal = () => {
      emit('close');
    }

    return {
      ...toRefs(data),
      saveFiles,
      closeModal
    }
  }
}
</script>

<style scoped>
  .o-modal__content .modal-card-head,
  ::v-deep(.o-modal__content .modal-card-head) {
    border: none;
  }
  .o-modal__content .modal-card-foot,
  ::v-deep(.o-modal__content .modal-card-foot) {
    border-top: 1px solid #a6a6a6;
  }
  ::v-deep(.file-lists) {
    clear: both;
    padding: 16px 8px;
    height: auto;
  }
  ::v-deep(.o-modal__content .modal-card-head),
  ::v-deep(.o-modal__content .modal-card-foot) {
    background-color: #fff !important;
  }
  ::v-deep(.is-pulled-right) {
    margin-bottom: 8px;
  }
</style>